/*----------------------------------
- CATALOG (SSOT): HOME TITLE
----------------------------------*/

/**
 * Home's `<title>`, set by its route (`pages/landing/index.tsx`) so the server render and the client's hydrated
 * `document.title` read the same words. With no `page.title` the two disagreed: the server falls back to the
 * identity's `web.fullTitle`, the client's page response to the bare app name (`APP_NAME`, "Unique Domains"), the
 * one heading row the website crawl read on `/` since 2026-11-01 (F1 of 2026-11-04).
 *
 * @docs docs/features/website-landing-experience
 * @rule The words are the identity's `web.fullTitle` (`identity.config.ts`), and they are longer than the server's
 *       suffix room (70 characters less " | Unique Domains"), so the server adds no suffix and the rendered title stays
 *       as it was: `tests/unit/website-home-title.test.ts` pins both.
 */

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const HOME_PAGE_TITLE = 'One-word domains with pricing, evidence, and risk context';
